import client from './client';
import type {
  CostSummary,
  CostByService,
  CostByCategory,
  CostByServiceEnv,
  CostTrend,
  CostAnomaly,
  UnattributedAccount,
} from '@/types';

export interface CostPeriodParams {
  period_start?: string;
  period_end?: string;
}

export async function fetchCostSummary(params?: CostPeriodParams) {
  const { data } = await client.get<CostSummary>('/costs/summary', { params });
  return data;
}

export async function fetchCostByService(params?: CostPeriodParams) {
  const { data } = await client.get<CostByService[]>('/costs/by-service', { params });
  return data;
}

export async function fetchCostByCategory(params?: CostPeriodParams) {
  const { data } = await client.get<CostByCategory[]>('/costs/by-category', { params });
  return data;
}

export async function fetchCostTrends(params?: CostPeriodParams & { granularity?: string }) {
  const { data } = await client.get<CostTrend>('/costs/trends', { params });
  return data;
}

export async function fetchCostAnomalies(params?: CostPeriodParams) {
  const { data } = await client.get<CostAnomaly[]>('/costs/anomalies', { params });
  return data;
}

export async function fetchCostByServiceEnv(
  params?: CostPeriodParams & { group?: string },
) {
  const { data } = await client.get<CostByServiceEnv[]>('/costs/by-service-env', { params });
  return data;
}

export async function fetchUnattributedCosts(params?: CostPeriodParams) {
  const { data } = await client.get<UnattributedAccount[]>('/costs/unattributed', { params });
  return data;
}

